import React from 'react'
import {
  Tooltip,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Zoom from '@material-ui/core/Zoom'

const useStyles = makeStyles((_theme) => ({}))

function CustomTooltip (props) {
  const classes = useStyles()

  return (
    <Tooltip
      title={ props.title }
      placement={ props.placement || 'right' }
      arrow
      interactive
      TransitionComponent={ Zoom }
      classes={{ tooltip: classes.tooltip }}
    >
      { props.children }
    </Tooltip>
  )
}

export default CustomTooltip
